export type KkmServerErrorCode =
  | 'bridge_missing'
  | 'cancellation_unsupported'
  | 'component_missing'
  | 'device_busy'
  | 'kkt_not_found'
  | 'malformed_response'
  | 'operation_timeout'
  | 'unsupported_mapping';

export type KkmServerOperationOutcome = 'known_not_run' | 'unknown' | 'user_cancelled';

export interface KkmServerErrorDetails {
  code: KkmServerErrorCode;
  command: string | null;
  operationId: string | null;
  outcome: KkmServerOperationOutcome;
  safeMessage: string;
}

export class KkmServerAdapterError extends Error {
  public readonly code: KkmServerErrorCode;

  public readonly command: string | null;

  public readonly operationId: string | null;

  public readonly outcome: KkmServerOperationOutcome;

  public constructor(details: KkmServerErrorDetails) {
    super(details.safeMessage);
    this.name = 'KkmServerAdapterError';
    this.code = details.code;
    this.command = details.command;
    this.operationId = details.operationId;
    this.outcome = details.outcome;
  }
}

/**
 * Единственная формулировка неоднозначного исхода. Кассир не должен получать
 * разные тексты для одного и того же состояния «неизвестно, выполнилась ли команда».
 */
export const AMBIGUOUS_OUTCOME_MESSAGE =
  'Неясно, завершилась ли операция. Не повторяйте её вручную: Mors проверит результат.';

export function debugAdapterIssue(event: string, context: Record<string, unknown>): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console -- Dev-only диагностика не попадает в production runtime.
    console.debug(`[KkmServerAdapter.${event}]`, context);
  }
}
